module.exports = __webpack_public_path__ + "static/media/bed_linen.bc958509.svg";